module.exports = "<h1>GUI Images</h1>\n<div class=\"col-md-6\">\n  <h4>GGW Devices</h4>\n</div>\n<div class=\"col-md-6\">\n  <h4>Images</h4>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/project/components/gui-image/gui-image.component.html
// module id = ../../../../../src/app/modules/project/components/gui-image/gui-image.component.html
// module chunks = main